import { useState, useEffect, useContext } from 'react'

import { enqueueSnackbar } from 'notistack'
import _ from 'lodash'

import { List, ListItem, Typography, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'

import { AppContext } from '/providers/app-context'
import { saveClientDetails } from '../../providers/clients-api'
import Item from './edit-item'

const AccountAdmin = () => {

  const { apiSource, apiKey, processing, setProcessing, client, refreshClient } = useContext(AppContext)

  const [editing, setEditing] = useState(false)
  const [clientCopy, setClientCopy] = useState()
  const [nameError, setNameError] = useState("")
  const [addressError, setAddressError] = useState("")
  const [validity, setValidity] = useState({ name: true, address: true })

  useEffect(() => {
    setClientCopy(_.cloneDeep(client))
  }, [client])

  useEffect(() => {
    if (clientCopy) {
      setNameError(validity.name ? "" : "Your, or your company name is required.")
      setAddressError(validity.address ? "" : "Your, or your company address is required.")
    }
  }, [validity])

  const setClientValue = (field, e) => {

    const isValid = e.target.validity.valid

    let v = _.clone(validity)
    v[field] = isValid
    setValidity(v)

    let c = _.clone(clientCopy)
    c[field] = e.target.value
    setClientCopy(c)
  }

  const edit = () => {
    setEditing(true)
    setClientCopy(_.clone(client))
  }

  const save = async () => {
    setEditing(false)
    setProcessing(true)
    enqueueSnackbar({ message: "Saving Company Details", variant: 'light' })
    await saveClientDetails({ apiSource, apiKey, client: clientCopy })
    // TODO Add error handling
    enqueueSnackbar({ message: "Company Details Saved", variant: 'success' })
    setProcessing(false)

    setEditing(false)
    refreshClient()
  }

  return (
    <div className='flex w-full flex-col gap-5 p-5'>
        <div className='flex flex-col gap-5'>
          <Typography variant='h4'>
            <div className='flex flex-row gap-20'>
              <div>Company Details</div>
              <Button variant="outlined" startIcon={<EditIcon />} onClick={() => edit()} disabled={processing || !client} sx={{ display: editing ? 'none' : '' }}>Edit</Button>
            </div>
          </Typography>

          <List>

            <Item title="Name" client={client} clientCopy={clientCopy} field="name" change={setClientValue} editing={editing} format="text" required={true} error={!validity.name} helperText={nameError} />
            <Item title="Address" client={client} clientCopy={clientCopy} field="address" change={setClientValue} editing={editing} format="multiline" required={true} error={!validity.address} helperText={addressError} />
            <Item title="Company Number" client={client} clientCopy={clientCopy} field="company_number" change={setClientValue} editing={editing} format="text" />
            <Item title="VAT Number" client={client} clientCopy={clientCopy} field="vat_number" change={setClientValue} editing={editing} format="text" />

            <ListItem sx={{ display: editing ? '' : 'none' }}>
              <div className='flex flex-row justify-between w-full'>
                <Button variant='outlined' startIcon={<CancelOutlinedIcon />} onClick={() => setEditing(false)}>Cancel</Button>
                <Button variant='contained' startIcon={<SaveOutlinedIcon />} onClick={save} disabled={!validity.name || !validity.address}>Save</Button>
              </div>
            </ListItem>

          </List>
        </div>
    </div>
  )
}

export default AccountAdmin
